export const POSTGRES_SSL_MODES = ['disable', 'allow', 'prefer', 'require', 'verify-ca', 'verify-full'] as const;

export type PostgresSslMode = (typeof POSTGRES_SSL_MODES)[number];
